module.exports = __webpack_public_path__ + "img/01宋雷.0804a65c.jpg";